var _excluded = ["classes", "columnHeading"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/no-array-index-key, no-return-assign */
import * as React from 'react';
import cs from 'classnames';
import PropTypes from 'prop-types';
import { getWidth, calculateHeaderOffsetValues } from '../utils/utils';
require("../table.css");
var styles = {
  "tableContainer": "tableContainer-3T4nC",
  "table": "table-f-a8c",
  "tableHead": "tableHead-1I1sp",
  "tableColHeader": "tableColHeader-2lgsb",
  "tableColHeaderSticky": "tableColHeaderSticky-311gH",
  "tableBody": "tableBody-1Sc4P",
  "tableRow": "tableRow-1zSWQ",
  "tableRowHeader": "tableRowHeader-boQgE",
  "tableCell": "tableCell-2u8UM"
};
var TableHead = _ref => {
  var {
      classes,
      columnHeading
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var trRef = null;
  var [width, setWidth] = React.useState(getWidth());
  var [headingOffsetLeftValues, setHeadingOffsetLeftValues] = React.useState([]);
  React.useEffect(() => {
    setWidth(getWidth());
  }, []);
  React.useEffect(() => {
    setWidth(getWidth());
    setHeadingOffsetLeftValues([]);
    var handleResize = () => {
      setHeadingOffsetLeftValues([]);
      setWidth(getWidth());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setWidth, setHeadingOffsetLeftValues]);
  React.useEffect(() => {
    if (trRef !== null) {
      setHeadingOffsetLeftValues(calculateHeaderOffsetValues(trRef));
    }
  }, [width, setHeadingOffsetLeftValues, trRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, columnHeading.length > 0 && /*#__PURE__*/React.createElement("thead", _extends({
    className: cs(styles.tableHead, classes.tableHead)
  }, otherProps), /*#__PURE__*/React.createElement("tr", {
    className: styles.tableHeadRow,
    ref: el => trRef = el
  }, columnHeading.map((col, idx) => {
    var title = col !== null && col !== void 0 && col.value ? col.value : null;
    var {
      span = 1,
      isSticky = false
    } = col;
    var thStyles = isSticky && idx !== 0 && headingOffsetLeftValues[idx] !== undefined ? {
      left: "".concat(headingOffsetLeftValues[idx], "px")
    } : null;
    return /*#__PURE__*/React.createElement("th", {
      className: cs(styles.tableColHeader, classes.tableColHeader, {
        [styles.tableColHeaderSticky]: isSticky
      }),
      colSpan: span,
      key: "th-".concat(title, "-").concat(idx),
      scope: "col",
      style: thStyles
    }, title);
  }))));
};
TableHead.defaultProps = {
  classes: {
    tableColHeader: '',
    tableHead: ''
  }
};
TableHead.propTypes = {
  columnHeading: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    colSpan: PropTypes.number,
    isSticky: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  })])).isRequired,
  classes: PropTypes.shape({
    tableColHeader: PropTypes.string,
    tableHead: PropTypes.string
  })
};
export default TableHead;